import React from 'react';

import { createStyles, withStyles, Theme } from '@material-ui/core';
import { StarOutline } from '@material-ui/icons';

import styles from '../analytics.module.css';

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface TeamDetailsProps {
  type: string;
  pos: number;
  name: string;
  awbs: number;
  orders: number;
  wgts: number;
  pcs: number;
  docs: string;
  waitlist: string;
  payment: string;
  screen: string;
  dim: string;
};

const TeamDetails = (props: TeamDetailsProps) => {

  return (
    <div className={`${styles.teWrapper}`}>
      <div className={`${styles.topScreener} ${styles.teRatingWrapper}`}>
        <span className={`${styles.tsStarWrapper}`}>
          <StarOutline
            classes={{
              root: `${styles.tsStar} ${styles.teStar}`
            }}
          />
          <span className={`${styles.tsNo} ${styles.teNo}`}>{props.pos}</span>
        </span>
        <small className={`${styles.tsName}`}>{props.name}</small>
      </div>
      <div className={`${styles.teDataWrapper} ${styles.teFlexWrapper}`}>
        <div className={`${styles.teDataItem}`}>
          <p className={styles.teData}><b>{props.awbs}</b></p>
          <p className={styles.teDataUnit}>AWBS</p>
        </div>
        <div className={`${styles.teDataItem}`}>
          <p className={styles.teData}><b>{props.orders}</b></p>
          <p className={styles.teDataUnit}>ORDERS</p>
        </div>
        <div className={`${styles.teDataItem}`}>
          <p className={styles.teData}><b>{props.wgts}</b></p>
          <p className={styles.teDataUnit}>KILOS</p>
        </div>
        <div className={`${styles.teDataItem}`}>
          <p className={styles.teData}><b>{props.pcs}</b></p>
          <p className={styles.teDataUnit}>PIECES</p>
        </div>
        {props.type == 'counter' && (
          <>
            <div className={`${styles.teDataItem}`}>
              <p className={styles.teData}><b>{props.payment}</b></p>
              <p className={styles.teDataUnit}>Payment Accuracy</p>
            </div>
            <div className={`${styles.teDataItem}`}>
              <p className={styles.teData}><b>{props.waitlist}</b></p>
              <p className={styles.teDataUnit}>Waitlist Usage</p>
            </div>
            <div className={`${styles.teDataItem}`}>
              <p className={styles.teData}><b>{props.docs}</b></p>
              <p className={styles.teDataUnit}>Docs Attachment</p>
            </div>
          </>
        )}
        {props.type == 'warehouse' && (
          <>
            <div className={`${styles.teDataItem}`}>
              <p className={styles.teData}><b>{props.dim}</b></p>
              <p className={styles.teDataUnit}>Dimming Ratio</p>
            </div>
            <div className={`${styles.teDataItem}`}>
              <p className={styles.teData}><b>{props.screen}</b></p>
              <p className={styles.teDataUnit}>Screening Ratio</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default withStyles(materialStyles)(TeamDetails);
